import ApiService from "./apiService";

import { BEConfig } from "../config/env";

import { webapiPost, webapiPut } from "../webapis/core";

class AuthService extends ApiService {
  authenticateUserByEmail = async email => {
    const apiURL = `${this.getBaseUrl()}${
      BEConfig.customerApi.authenticateUser
    }`;
    const response = await webapiPost(
      this.getAccessToken(),
      apiURL,
      { email },
      this.getVisitorId(),
      this.getLanguage()
    ).request;
    return response.data;
  };

  getRegistrationStatus = async registrationData => {
    const apiURL = `${this.getBaseUrl()}${
      BEConfig.customerApi.getRegistrationDataStatus
    }`;
    const response = await webapiPost(
      this.getAccessToken(),
      apiURL,
      registrationData,
      this.getVisitorId(),
      this.getLanguage()
    ).request;
    return response.data;
  };

  startRegistration = async registrationData => {
    const apiURL = `${this.getBaseUrl()}${
      BEConfig.customerApi.beginUserRegistration
    }`;
    const response = await webapiPost(
      this.getAccessToken(),
      apiURL,
      registrationData,
      this.getVisitorId(),
      this.getLanguage()
    ).request;
    return response.data;
  };

  // New method for initiating mobile number verification flow
  initiateMobileVerification = async ({ token }) => {
    const apiURL = `${this.getBaseUrl()}user/email`;
    const response = await webapiPut(
      this.getAccessToken(),
      apiURL,
      { token },
      this.getVisitorId()
    ).request;
    return response.data;
  };

  // New method for completing mobile number verification with OTP
  completeMobileVerification = async ({ token, otp }) => {
    const apiURL = `${this.getBaseUrl()}user/email/complete`;
    const response = await webapiPut(
      this.getAccessToken(),
      apiURL,
      { token, otp },
      this.getVisitorId()
    ).request;
    return response.data;
  };

  deactivatePreviousAccounts = async ({ token = "", otp = "" }) => {
    const apiURL = `${this.getBaseUrl()}${
      BEConfig.customerApi.deactivatePreviousAccounts
    }`;
    const response = await webapiPost(
      this.getAccessToken(),
      apiURL,
      { token, otp },
      this.getVisitorId(),
      this.getLanguage()
    ).request;
    return response.data;
  };

  completerRegistration = async ({ token = "", otp = "" }) => {
    const apiURL = `${this.getBaseUrl()}${
      BEConfig.customerApi.completeUserRegistration
    }`;
    const response = await webapiPost(
      this.getAccessToken(),
      apiURL,
      { token, otp },
      this.getVisitorId(),
      this.getLanguage()
    ).request;
    return response.data;
  };

  verifyUpdateComplete = async ({ token = "", otp = "" }) => {
    const apiURL = `${this.getBaseUrl()}${BEConfig.customerApi.verifyOtp}`;
    const response = await webapiPut(
      this.getAccessToken(),
      apiURL,
      { token, otp },
      this.getVisitorId()
    ).request;
    return response;
  };

  verifyUpdateCompleteAuthorize = async ({ token = "", otp = "" }) => {
    const apiURL = `${this.getBaseUrl()}${BEConfig.customerApi.loginOtpVerify}`;
    const response = await webapiPost(
      this.getAccessToken(),
      apiURL,
      { token, otp },
      this.getVisitorId()
    ).request;
    return response;
  };
  getBaseUrl() {
    const { baseURL, protocol, port, versionInfo } = BEConfig.customerApi;

    const url = `${protocol}${baseURL}${port}${versionInfo}`;

    return url;
  }

  async resendOtp({ token, channel = "sms" }) {
    const { baseURL, protocol, port, versionInfo } = BEConfig.customerApi;
    const endpoint = `${protocol}${baseURL}${port}${versionInfo}${BEConfig.customerApi.resendOTP}`;
    const response = await webapiPost(
      this.getAccessToken(),
      endpoint,
      { token, channel },
      this.getVisitorId()
    ).request;
    return response;
  }

  async sendOtp({ token, channel = "sms" }) {
    const { baseURL, protocol, port, versionInfo } = BEConfig.customerApi;
    const endpoint = `${protocol}${baseURL}${port}${versionInfo}${BEConfig.customerApi.sendOTP}`;
    const response = await webapiPost(
      this.getAccessToken(),
      endpoint,
      { token, channel },
      this.getVisitorId()
    ).request;
    return response;
  }

  async verifyOtp({ token, otp }) {
    const { baseURL, protocol, port, versionInfo } = BEConfig.customerApi;
    const endpoint = `${protocol}${baseURL}${port}${versionInfo}${BEConfig.customerApi.verifyOTP}`;
    const response = await webapiPost(
      this.getAccessToken(),
      endpoint,
      { token, otp },
      this.getVisitorId()
    ).request;
    return response;
  }
}

const instance = new AuthService();

export default instance;
